import React, { useState, useEffect } from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ManageClientInfo from './ManageClientInfo.redesign';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';

interface IClientSettingsProps {
    states?: PagedResultSet<State>;
    showDialog?: (dialogName: string) => void;
    hideDialog?: () => void;
}

export const ClientSettings = (props: IClientSettingsProps) => {
    const [renderPage, setRenderPage] = useState('');

    useEffect(() => {
        setRenderPage('clientInfo');
    }, []);

    const renderClientPage = () => {
        if (renderPage === 'clientInfo') {
            return (
                <>
                    <ManageClientInfo showDialog={props.showDialog} hideDialog={props.hideDialog} states={props.states} />
                </>
            );
        }

        return <div />;
    };

    const renderClientInfo = () => {
        setRenderPage('clientInfo');
    };

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <Button text="Client Information" onClick={renderClientInfo} />
            </div>
            <div>{renderClientPage()}</div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/project/sections/ClientSettings.tsx